const managedInputSelector = '.radiobuttonlist > div > input, .checkboxlist > div > input, .dataconsent input';
const checkedInputSelector = '.radiobuttonlist > div > input:checked, .checkboxlist > div > input:checked, .dataconsent input:checked';

function getManagedInput(target) {
    return target instanceof HTMLInputElement && target.matches(managedInputSelector) ? target : null;
}

function getInputLabel(input) {
    return input.parentElement?.querySelector('label') ?? null;
}

function syncCheckedState(input) {
    const label = getInputLabel(input);

    if (!label) {
        return;
    }

    if (input.matches('.radiobuttonlist > div > input')) {
        input.closest('.radiobuttonlist')?.querySelectorAll('label').forEach((radioLabel) => {
            radioLabel.classList.remove('__checked');
        });
    }

    label.classList.toggle('__checked', input.checked);
}

function setFocusState(input, isFocused) {
    getInputLabel(input)?.classList.toggle('__focused', isFocused);
}

function syncInitialCheckedStates() {
    document.querySelectorAll(checkedInputSelector).forEach((input) => {
        syncCheckedState(input);
    });
}

document.addEventListener('change', (event) => {
    const input = getManagedInput(event.target);

    if (!input) {
        return;
    }

    syncCheckedState(input);
});

document.addEventListener('focusin', (event) => {
    const input = getManagedInput(event.target);

    if (!input) {
        return;
    }

    setFocusState(input, true);
});

document.addEventListener('focusout', (event) => {
    const input = getManagedInput(event.target);

    if (!input) {
        return;
    }

    setFocusState(input, false);
});

document.addEventListener('click', (event) => {
    const resetButton = event.target instanceof Element ? event.target.closest('.__reset') : null;

    if (!resetButton) {
        return;
    }

    document.querySelectorAll('.radiobuttonlist label, .checkboxlist label').forEach((label) => {
        label.classList.remove('__checked');
    });
});

syncInitialCheckedStates();
